import Address from '@/classes/addresses/Address'
import Procedures from '@/classes/procedures/Procedures'
import Users from '@/classes/users/Users'
import Statistics from '@/classes/statistics/Statistics'
import MultiCurrency from '@/classes/currencies/MultiCurrency'
import { get as _get, pickBy as _pickBy } from 'lodash'

export default class Project {
  constructor ({ id = null, name = null, image = null, informations = {}, description = null, currency = null, status = null, slug = null, fixed_goal_amount = {}, address, campaign = {}, procedures = [], users = [], settings = {}, tags = [], amount_collected = {}, created_at = null, benefiting_id = null } = {}) {
    this.id = id
    this.name = name
    this.image = image
    this.informations = informations
    this.description = description
    this.currency = currency
    this.status = status
    this.slug = slug
    this.fixed_goal_amount = new MultiCurrency(fixed_goal_amount)
    this.address = new Address(_get(address, 'table', {}))
    this.campaign = campaign
    this.procedures = new Procedures(procedures)
    this.users = new Users(users)
    this.settings = settings
    this.tags = tags
    this.statistics = new Statistics({ amount_collected })
    this.created_at = created_at
    this.benefiting_id = benefiting_id
  }

  get donation_procedure () {
    return this.procedures.donation
  }

  get goal_amount () {
    return this.donation_procedure?.goal_amount
  }

  get start_date () {
    return this.donation_procedure?.start_date
  }

  get end_date () {
    return this.donation_procedure?.end_date
  }

  get is_started () {
    return this.donation_procedure?.is_started
  }

  get is_ended () {
    return this.donation_procedure?.is_ended
  }

  get is_ongoing () {
    return this.donation_procedure?.is_ongoing
  }

  get to_database () {
    return _pickBy({
      name: this.name,
      description: this.description,
      start_date: this.start_date,
      end_date: this.end_date,
      fixed_goal_amount: this.fixed_goal_amount.to_database
    }, value => value)
  }
}
